import { useQuery } from "react-query";
import api from "../services/api";

type getReferCountResponse = {
  referralSuccessCount: number;
};

async function getUserReferralSuccessCount() {
  const response = await api.get(`/rs/referral/success-count`);

  if (response.ok) {
    const json = (await response.json()) as getReferCountResponse;
    return json.referralSuccessCount;
  } else if (response.status === 404 || response.status === 400) {
    return 0;
  }

  throw new Error("Could not fetch user referral success count");
}

export default function useReferralSuccessCount() {
  return useQuery("user-referral-success-count", getUserReferralSuccessCount, {
    staleTime: 1000 * 60 // 60 seconds,
  });
}
